import { Component, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import {NgbModal}   from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import swal from 'sweetalert2';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { RouterModule } from '@angular/router'; 
import { ApidataService } from '../apidata.service';
import {HttpClient,} from '@angular/common/http';
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.css'
})
export class LoginModalComponent {
  authentication_token;
  user;
  idgoogle;

   constructor(private modalService: NgbModal,
      private router: Router,
      private apiservice: ApidataService,
       private http:HttpClient ,
      private elementRef: ElementRef,) {}
 @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.openModal();

  }
  goToSignIn() {
    if (this.modalService.hasOpenModals()) { 
      this.modalService.dismissAll(); 
    }
    setTimeout(() => {
      this.router.navigate(['/signin']); 
    }, 100);
  }
  goToSignUp() {
    if (this.modalService.hasOpenModals()) { 
      this.modalService.dismissAll(); 
    }
    setTimeout(() => {
      this.router.navigate(['/signup']); 
    }, 100);
  }
  openModal() {
    this.modalService.open(this.content, { backdrop: 'static', keyboard: false, centered: true, windowClass: 'my-class' });
  }

  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})

    }
  private initializeGoogleAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', () => {
        gapi.auth2
          .init({
            client_id:
              '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com',
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            // console.error('Error initializing Google Auth', error);
            reject(error);
          });
      });
    });
  }



  public googleLogin(): void {
    this.initializeGoogleAuth()
      .then(() => {
        const googleAuth = gapi.auth2.getAuthInstance();
        googleAuth
          .signIn({ scope: 'profile email' })
          .then((googleUser) => {
            this.onSignIn(googleUser);
          })
          .catch((error) => {
            // console.error('Google Sign-In failed', error);
          });
      })
      .catch((error) => {
        // console.error('Google API initialization failed', error);
      });
  }

  public onSignIn(googleUser): void {
    const profile = googleUser.getBasicProfile();
    const id_token = googleUser.getAuthResponse().id_token;
    const body = {
      firstname: btoa(profile.getGivenName()),
      lastname: btoa(profile.getFamilyName()),
      email: btoa(profile.getEmail()),
    };


    this.gLogin(body);
  }
  public gLogin(body): void {
    this.apiservice.signupinGoogle2(body).subscribe(
      (data) => {
        if (data.meta.code === 200) {
          localStorage.setItem('currentUser', JSON.stringify(data));
     
          this.user = data['response'];
          this.authentication_token = this.user['user'].authentication_token;
          this.idgoogle = this.user['user'].id;
          localStorage.setItem('fullname', this.user['user'].verify);
          localStorage.setItem(this.idgoogle, 'profile_id');
         
          localStorage.setItem('profile_id', this.idgoogle);
          localStorage.setItem(
            'authentication_token',
            this.user['user'].authentication_token
          );
          localStorage.setItem('token', this.user['user'].authentication_token);

          localStorage.setItem('role', '1');
        
          swal({
            background: '#FFFFFF',
            title: 'success',
            html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                  You have successfully logged into GrammarIn.
                  </p>
                </div>
              </div>
            </div>
          `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0);
          
          this.router.navigate(['/']).then(() => {
            window.location.reload();
          });

          // });
        } else if (data.meta.code === 400) {
          swal({
            background: '#FFFFFF',
            title: 'Error',
            html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                   You have already registered your account from the web.
                  </p>
                </div>
                <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                  border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                  class="mt-5 butn-alert">Ok</button>
              </div>
            </div>
          `,
            showConfirmButton: false,
            width: '323px',
            timer: 4000,
          });
          setTimeout(() => {
            const okButton = document.getElementById('swal-ok-button');
            if (okButton) {
              okButton.addEventListener('click', () => {
                swal.close();
              });
            }
          }, 0);
        }
      },
      (error) => {
        // console.error('Login error', error);
      }
    );
  }
  closeModal(){
    this.modalService.dismissAll();
  }

}
